<app-picker-manual-bultos
  *ngIf="showPickerManualBultos"
  (close)="closePickerManualBultos()"
></app-picker-manual-bultos>

<div class="scanner-container" *ngIf="!showPickerManualBultos">
  <div class="scanner-header">
    <h2>Escanea las ubicaciones para binear los bultos</h2>
  </div>

  <div class="scanner-content">
    <div class="cameras-grid">
      <button
        (click)="selectCamera(camera)"
        *ngFor="let camera of cameras"
        [class.active]="camera.id === activeCameraId"
        class="camera-button"
        mat-raised-button>
        <div class="camera-icon">{{ camera.humanLabel.split(' ')[0] }}</div>
        <span>{{ camera.humanLabel.split(' ').slice(1).join(' ') }}</span>
      </button>
    </div>

    <div class="scanner-wrapper">
      <ngx-scanner-qrcode
        #scanner
        [config]="scannerConfig"
        class="scanner-qr">
      </ngx-scanner-qrcode>

      <button *ngIf="retryButton" class="retryButton accept-btn" (click)="activateCameras()" mat-raised-button>
        <mat-spinner *ngIf="retryingCameras" class="loading" diameter="20"></mat-spinner>
        <mat-icon *ngIf="!retryingCameras" class="success">check_circle</mat-icon>
        <span>Activar Camaras</span>
      </button>

      <div *ngIf="status"
            [class.error]="currentStatus.type === 'error'"
            [class.loading]="currentStatus.type === 'loading'"
            [class.success]="currentStatus.type === 'success'"
            class="status-message">
        <mat-spinner *ngIf="currentStatus.type === 'loading'" diameter="20"></mat-spinner>
        <mat-icon *ngIf="currentStatus.type === 'error'">error_outline</mat-icon>
        <mat-icon *ngIf="currentStatus.type === 'success'">check_circle</mat-icon>
        <span>{{ currentStatus.message }}</span>
      </div>
    </div>

    <div class="location-selectors">
      <mat-form-field appearance="outline">
        <mat-label>Zona</mat-label>
        <mat-select [(ngModel)]="selectedLocation.c1">
          <mat-option *ngFor="let option of c1Options" [value]="option.key">
            {{ option.value }}
          </mat-option>
        </mat-select>
      </mat-form-field>

      <mat-form-field appearance="outline">
        <mat-label>Rack</mat-label>
        <mat-select [(ngModel)]="selectedLocation.c2">
          <mat-option *ngFor="let option of c2Options" [value]="option.key">
            {{ option.value }}
          </mat-option>
        </mat-select>
      </mat-form-field>

      <mat-form-field appearance="outline">
        <mat-label>Nivel</mat-label>
        <mat-select [(ngModel)]="selectedLocation.c3">
          <mat-option *ngFor="let option of c3Options" [value]="option.key">
            {{ option.value }}
          </mat-option>
        </mat-select>
      </mat-form-field>

      <mat-form-field appearance="outline">
        <mat-label>Posición</mat-label>
        <mat-select [(ngModel)]="selectedLocation.c4">
          <mat-option *ngFor="let option of c4Options" [value]="option.key">
            {{ option.value }}
          </mat-option>
        </mat-select>
      </mat-form-field>
    </div>
  </div>

  <div class="action-buttons">
    <button
      (click)="cancel()"
      [disabled]="lockUserInteraction"
      class="cancel-btn"
      mat-stroked-button>
      <mat-icon>close</mat-icon>
      <span>Cancelar</span>
    </button>

    <button
      (click)="acceptLocation()"
      [disabled]="!isLocationValid() || lockUserInteraction"
      class="accept-btn"
      color="primary"
      mat-raised-button>
      <mat-icon>check</mat-icon>
      <span>Aceptar ubicación</span>
    </button>
  </div>
</div>
